import React, { useState } from 'react'
import { PainelProps } from './styles'
import ButtonCustom from '../../../../../../../Components/ButtonCustom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faDownLeftAndUpRightToCenter,
  faEdit,
  faPlus,
  faUpload,
  faUpRightAndDownLeftFromCenter,
  faXmark,
} from '@fortawesome/free-solid-svg-icons'
import { Render } from '../../../../../../../Components/CustomUi/render'
import { Select } from '../../../../../../../Components/CustomUi/Select'
import { LineDivider } from '../../../../../../../Components/CustomUi/LineDivider'
import { TalhaoCultivaveisItens } from '../../../../../../../services/TalhaoSafra'
import { HeaderTable } from '../../../../../../../Components/CustomUi/table/headerTable'
import { BodyTable } from '../../../../../../../Components/CustomUi/table/bodyTable'
import { RowTable } from '../../../../../../../Components/CustomUi/table/rowTable'
import { RowItem } from '../../../../../../../Components/CustomUi/table/rowItem'
import Icon from '@ant-design/icons'
import Svg from '../../../../../../../Components/talhasvg'
import { Empty, Upload } from 'antd'
import { TabelaPropSubArea } from '../tabela'
import { customRequest } from '../../../../../../../services/Afins'
import { UploadChangeParam } from 'antd/es/upload'

interface Props {
  onClose: Function
  dadosSubArea: any[]
  dadosTalhao: TalhaoCultivaveisItens[]
  margem?: number
  excluir_subarea: Function
  baixarKmlSubarea: Function
  editarSubArea: Function
  salvarEditar: Function
  importarSubarea: (info: UploadChangeParam) => Promise<void>
  novaSubArea: Function
  editIndexSubTalhao: number
  nome: string
  setNome: React.Dispatch<React.SetStateAction<string>>
  urlRef: React.RefObject<HTMLAnchorElement>
  confirmar_exclusao: boolean
  setConfirmar_exclusao: React.Dispatch<React.SetStateAction<boolean>>
  id_item_atual: number
  setId_item_atual: React.Dispatch<React.SetStateAction<number | string>>
  setNome_item_atual: React.Dispatch<React.SetStateAction<string>>
  fake_loading: boolean
  talhaoSelect: number
  recordMap: boolean
  loadingSalvar: boolean
  fecharCard: Function
}

export const PainelCard: React.FC<Props> = ({
  onClose,
  dadosSubArea,
  dadosTalhao,
  margem,
  baixarKmlSubarea,
  editarSubArea,
  salvarEditar,
  excluir_subarea,
  importarSubarea,
  novaSubArea,
  editIndexSubTalhao,
  nome,
  setNome,
  urlRef,
  confirmar_exclusao,
  setConfirmar_exclusao,
  id_item_atual,
  setId_item_atual,
  fake_loading,
  setNome_item_atual,
  talhaoSelect,
  recordMap,
  loadingSalvar,
  fecharCard
}) => {
  const [shrink, setShrink] = useState<boolean>(false)
  return (
    <PainelProps data-shrink={shrink} style={{ top: margem, left: margem }}>
      <div style={{ width: '100%', justifyContent: 'space-between', display: 'flex' }}>
        <ButtonCustom
          onClick={() => {
            onClose();
            fecharCard()
          }}
          type='tertiary'
          danger
          icon={<FontAwesomeIcon icon={faXmark} />}
          style={{ marginLeft: -15, alignSelf: 'flex-start' }}
        >
          Fechar
        </ButtonCustom>
        <ButtonCustom
          onClick={() => {
            setShrink(!shrink)
          }}
          type={shrink ? 'primary' : 'tertiary'}
          icon={
            <FontAwesomeIcon
              icon={shrink ? faUpRightAndDownLeftFromCenter : faDownLeftAndUpRightToCenter}
            />
          }
          style={{ marginLeft: -15, alignSelf: 'flex-start' }}
        />
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 5, marginTop: '10px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <label style={{ fontWeight: '700' }}>Nome talhão</label>
          <label style={{ fontWeight: '700' }}>Área/ha</label>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <p style={{ margin: 0, padding: 0, fontWeight: '500' }}>{dadosTalhao[0]?.nome}</p>
          <p style={{ margin: 0, padding: 0, fontWeight: '500' }}>{dadosTalhao[0]?.area}</p>
        </div>
      </div>

      <LineDivider />

      <TabelaPropSubArea
        dados_subarea={dadosSubArea}
        excluir_subarea={excluir_subarea}
        baixarKmlSubarea={baixarKmlSubarea}
        editarSubArea={editarSubArea}
        salvarEditar={salvarEditar}
        editIndexSubTalhao={editIndexSubTalhao}
        nome={nome}
        setNome={setNome}
        urlRef={urlRef}
        confirmar_exclusao={confirmar_exclusao}
        setConfirmar_exclusao={setConfirmar_exclusao}
        id_item_atual={id_item_atual}
        setId_item_atual={setId_item_atual}
        setNome_item_atual={setNome_item_atual}
        fake_loading={fake_loading}
        loadingSalvar={loadingSalvar}
      />

      <LineDivider />
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
        <ButtonCustom icon={<FontAwesomeIcon icon={recordMap ? faXmark : faPlus } />} onClick={novaSubArea} style={{backgroundColor: recordMap ? 'red': '#5da57d'}}>
          Desenhar subárea
        </ButtonCustom>
        <Upload
          {...customRequest}
          disabled={talhaoSelect <= 0}
          accept='.kml'
          onChange={importarSubarea}
          style={{
            minWidth: '100%',
          }}
          showUploadList={false}
        >
          <ButtonCustom
            type='secondary'
            icon={<FontAwesomeIcon icon={faUpload} />}
            onClick={undefined}
          >
            Importar kml
          </ButtonCustom>
        </Upload>
      </div>
    </PainelProps>
  )
}
